import { CreateFocusCss, isPhoneInLandscape } from '../../../../styles'
import { scrollShadow } from '../../../../utilities'
import type { Tokens } from '../../../../theming/types'
import type { ModalBodyProps } from '..'

export default (config: {
  props: Partial<ModalBodyProps> & { observe?: boolean }
  tokens: Tokens
}) => {
  const { props, tokens } = config
  return {
    default: {
      body: {
        ...tokens.fontBodyM,
        padding: props.noPadding ? 0 : '24px',

        [isPhoneInLandscape]: {
          padding: props.noPadding ? 0 : '10px',
        },

        ...(props.observe && {
          ...CreateFocusCss(tokens.focusInner),
        }),
      },

      shadowTop: {
        ...scrollShadow({
          direction: 'down',
          height: '4px',
          shadowColorStart: tokens.elevationContainerScrollTop,
          shadowColorEnd: tokens.elevationContainerScrollBottom,
        }),
      },

      shadowBottom: {
        ...scrollShadow({
          direction: 'up',
          height: '4px',
          shadowColorStart: tokens.elevationContainerScrollTop,
          shadowColorEnd: tokens.elevationContainerScrollBottom,
        }),
      },
    },

    scrollShadow: {
      shadowTop: {
        opacity: 1,
      },

      shadowBottom: {
        opacity: 1,
      },
    },
  } as const
}
